import styled from 'styled-components';

export const Fotter = styled.div`
  display: flex;
`;

export const Box = styled.div`
  &:not(&:last-of-type) {
    padding-bottom: 30px;
  }
`;

export const Divider = styled.div`
  border-bottom: 1px solid #ebebeb;
  margin-top: 30px;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 10px;
`;
